import 'jquery';
import '../utils/slick.js';

$(function () {
    var slider = $('.hv2-reviews .hv2-reviews__review-list');
    var counterElement = $('<div class="counter"><span class="current-slide"></span><span class="separator-slide">/</span><span class="total-slides"></span></div>');

    slider.slick({
        centerMode: true,
        centerPadding: '30%',
        slidesToShow: 1,
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '25%',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30px',
                    centerMode: true,
                }
            }
        ]
    });

    function updateSlideCounter() {
        var currentSlide = slider.slick('slickCurrentSlide') + 1;
        counterElement.find('.current-slide').text(currentSlide.toString().padStart(2, '0'));
    }

    function initializeSlideCounter() {
        checkCounter();
        var totalSlides = slider.find('.slick-slide:not(.slick-cloned)').length;
        counterElement.find('.total-slides').text(totalSlides.toString().padStart(2, '0'));
        updateSlideCounter();
    }

    function checkCounter(){
        if ($('.hv2-reviews .hv2-reviews__review-list .counter').length === 0) {
            $('.hv2-reviews .hv2-reviews__review-list .arrow-left').after(counterElement);
        }
    }

    slider.on('afterChange', function () {
        updateSlideCounter();
    });

    $(window).on('resize orientationchange', function () {
        setTimeout(function(){
            initializeSlideCounter();
        }, 100);
    });

    initializeSlideCounter();
});